import { ViewType } from "../types/navigation";

export const APP_VIEWS: ReadonlyArray<ViewType> = [
  "dashboard",
  "projects",
  "tasks",
  "users",
  "materials",
  "reports",
  "settings",
  "team",
  "worklog",
  "revenue",
  "assignments",
  "archives",
  "project-status",
  "documentation",
  "billing",
  "activity-logs",
  "feature-bank",
];

const APP_VIEW_SET = new Set<string>(APP_VIEWS);
const LEGACY_VIEW_ALIASES: Record<string, ViewType> = {
  "admin-projects": "projects",
  "admin-tasks": "tasks",
};

export const normalizeView = (value: string): ViewType | null => {
  const normalized = value.replace(/^#|^\/+|\/+$/g, "").split("?")[0];
  if (LEGACY_VIEW_ALIASES[normalized]) return LEGACY_VIEW_ALIASES[normalized];
  return APP_VIEW_SET.has(normalized) ? (normalized as ViewType) : null;
};

export const pathForView = (view: ViewType): string =>
  `/${normalizeView(view) ?? "dashboard"}`;

export const viewFromLocation = (
  location: Pick<Location, "pathname" | "hash">,
): ViewType | null => {
  const legacyHash = normalizeView(location.hash);
  if (legacyHash) return legacyHash;
  return normalizeView(location.pathname);
};

export const navigateToView = (view: ViewType, replace = false): void => {
  if (typeof window === "undefined") return;
  const normalizedView = normalizeView(view) ?? "dashboard";
  const url = new URL(window.location.href);
  url.pathname = pathForView(normalizedView);
  url.search = "";
  url.hash = "";

  window.history[replace ? "replaceState" : "pushState"]({}, "", url);
  try {
    localStorage.setItem("currentView", normalizedView);
  } catch {}
  window.dispatchEvent(new PopStateEvent("popstate"));
};

